import { Stack, Table, Text, Title } from '@mantine/core';
import { useContractors, useYukleniciPersoneli } from '../api/queries';
import { KIMLIK_TIPI_ETIKET } from '../i18n/tr';
import { SahaGirisiNedenleri, SahaGirisiRozeti } from './evrak-parts';
import { BosListeNotu, QueryStatus } from './parts';

/**
 * Portal — personel listesi (F1.5·S12; **TUR 6 / P1**): firmasının AKTİF
 * istihdamlı kişileri, KİŞİ DÜZEYİ saha girişiyle (K1 — kişi bazlı evrak
 * satırından okunur). Kaynak `contractors/:id/personel` (temsilci kendi
 * firması). Kimlik MASKELİ; doğum tarihi bu yüzeyde YOKTUR — sunucu da
 * göndermez (S8).
 */
export function PortalPersonelScreen(): React.JSX.Element {
  const contractors = useContractors();
  const firmaId = contractors.data?.[0]?.id ?? '';
  const personel = useYukleniciPersoneli(firmaId);
  return (
    <Stack>
      <Title order={3}>Personel</Title>
      <QueryStatus queries={[contractors, personel]} />
      {personel.data?.length === 0 && (
        <BosListeNotu mesaj="Firmanızda kayıtlı aktif personel yok — Personel yükleme ekranından liste yükleyebilirsiniz." />
      )}
      {personel.data && personel.data.length > 0 && (
        <>
          <Table striped highlightOnHover data-testid="portal-personel-listesi">
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Ad soyad</Table.Th>
                <Table.Th>Kimlik</Table.Th>
                <Table.Th>Görev</Table.Th>
                <Table.Th>Saha girişi</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {personel.data.map((kisi) => (
                <Table.Tr key={kisi.personId} data-testid="portal-personel-satiri">
                  <Table.Td>{kisi.adSoyad}</Table.Td>
                  <Table.Td>
                    {KIMLIK_TIPI_ETIKET[kisi.kimlikTipi]} · {kisi.kimlikNoMaskeli}
                  </Table.Td>
                  <Table.Td>{kisi.rol}</Table.Td>
                  <Table.Td>
                    <SahaGirisiRozeti
                      sahaGirisi={kisi.sahaGirisi}
                      testId="portal-kisi-saha-girisi"
                    />
                    <SahaGirisiNedenleri sahaGirisi={kisi.sahaGirisi} />
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
          <Text size="xs" c="dimmed">
            Kişi bazlı evrakları Firmam sayfasından yükleyebilirsiniz.
          </Text>
        </>
      )}
    </Stack>
  );
}
